/**
 *
 * Asynchronously loads the component for AdvisorClientSubscription
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorClientSubscription = lazyLoad(
  () => import('./index'),
  module => module.AdvisorClientSubscription,
);
